import { z } from 'zod';
import { CLARA_TRIGGERS } from '../constants/business/clara';
import { bigintStringSchema } from './clara-actions';

/**
 * The `run-claim-agent` job payload (CUR-1160): the org and claim the run is scoped to, the
 * trigger that woke it and an optional correlation id that groups its LLM request log rows. Ids
 * travel as decimal strings, as the action inputs do; the job converts them with `BigInt`. The
 * payload is the trust boundary of the run: the trigger pipeline derives it from an audited write,
 * and nothing the model produces can change it.
 */
export const claraRunJobPayloadSchema = z
    .object({
        orgId: bigintStringSchema,
        claimId: bigintStringSchema,
        trigger: z.enum(CLARA_TRIGGERS),
        correlationId: z.uuid().optional(),
    })
    .strict();
export type ClaraRunJobPayload = z.infer<typeof claraRunJobPayloadSchema>;
